import urlUtils from 'url';
import escapeStringRegexp from 'escape-string-regexp';
import getConfig from 'next/config';

import { api as apiRequest } from './request';
import { logError } from './logger';

const { serverRuntimeConfig } = getConfig();

export const redirect = async (url, logger) => {
	try {
		const { pathname: from, query } = urlUtils.parse(url, true);
		const data = await apiRequest('redirects/match', { from });

		if (data) {
			const parsedUrl = urlUtils.parse(data.to, true);
			const redirectUrl = urlUtils.format({
				...parsedUrl,
				search: null,
				query: { ...query, ...parsedUrl.query }
			});

			return { url: redirectUrl, status: data.status };
		}
	} catch (err) {
		logger.logError(err.message);
	}

	return undefined;
};

export const instituteRedirect = async (resolvedUrl, sysName) => {
	let redirectData = {};

	if (sysName && !/^\d+-/.test(sysName)) {
		const { items } = await apiRequest('institutes', {
			names: [sysName],
			fields: 'sysName'
		});

		if (items.length) {
			const url = resolvedUrl.replace(
				new RegExp(
					`(?<=[/?&]institute[-=])${escapeStringRegexp(sysName)}(?=[/?&]|$)`
				),
				items[0].sysName
			);

			redirectData = {
				url: `${serverRuntimeConfig.basePath || ''}${url}`,
				status: 301
			};
		}
	}

	return redirectData;
};

const wellKnownLocales = ['moskva', 'sankt-peterburg', 'sevastopol'];
const localeSysNameRegExp = /(^|-)(oblast|respublika|kra[yi]|avtonomny[yi]-okrug)(-|$)/;
export const locationRedirect = async (resolvedUrl, name) => {
	let redirectData = {};

	if (
		name &&
		!wellKnownLocales.includes(name) &&
		!localeSysNameRegExp.test(name)
	) {
		try {
			const { localeNames } = await apiRequest('location/getLocation', {
				name
			});

			if (localeNames && localeNames.length && !localeNames.includes(name)) {
				const sysName = localeNames.reduce((prev, next) =>
					next.length < prev.length ? next : prev
				);

				const url = resolvedUrl.replace(
					new RegExp(`(?<=/)${escapeStringRegexp(name)}(?=[/?]|$)`),
					sysName
				);

				redirectData = {
					url: `${serverRuntimeConfig.basePath || ''}${url}`,
					status: 301
				};
			}
		} catch (err) {
			if (err.statusCode !== 404) {
				logError(`location redirect error: ${err.stack || err}`);
			}
		}
	}

	return redirectData;
};
